import React from 'react';
import Header from '../../components/Header/Header';

const Home = () => {
    return (
      <div>
        <Header/>
      </div>
    );
};

export default Home;